import { useState, useEffect, useRef } from "react"

const INACTIVITY_LIMIT = 30000

export const useTimer = () => {
  const [activeTime, setActiveTime] = useState(0)
  const [isActive, setIsActive] = useState(true)
  const [pydioId, setPydioId] = useState(null)
  const lastActivityTime = useRef(Date.now())
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const isWindowActive = useRef(true)

  const isActiveRef = useRef(isActive)
  useEffect(() => {
    isActiveRef.current = isActive
  }, [isActive])

  useEffect(() => {
    if (pydioId) {
      localStorage.setItem('order_time', JSON.stringify({ pydio_id: pydioId, time: activeTime }));
    }
  }, [activeTime])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        isWindowActive.current = false
        setIsActive(false)
      } else {
        isWindowActive.current = true
        setIsActive(true)
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  const updateActivity = () => {
    setIsActive(true)
    lastActivityTime.current = Date.now()
  }

  const startTimer = (pydioId) => {
    if (intervalRef.current) return

    const orderStorage = JSON.parse(localStorage.getItem('order_time') || 'null');
    const time = orderStorage?.pydio_id === pydioId ? orderStorage.time : 0

    setPydioId(pydioId)
    
    setActiveTime(time)

    document.addEventListener("mousemove", updateActivity)
    document.addEventListener("keydown", updateActivity)
    document.addEventListener("click", updateActivity)
    document.addEventListener("scroll", updateActivity)

    intervalRef.current = setInterval(() => {
      if (isActiveRef.current) {
        setActiveTime((prev) => prev + 1)
      }

      if (Date.now() - lastActivityTime.current > INACTIVITY_LIMIT) {
        setIsActive(false)
      }
    }, 1000)
  }

  return { activeTime, isActive, startTimer }
}
